var map;
var InfoObj = [];

var icons = {
  par2:{
    icon: 'https://cdn.shopify.com/s/files/1/0495/7532/9941/files/PAR2-pointer.png?v=1677793895'
  }
};

var markersOnMap = [
  {
    storecode: 'P02',
    placeName: 'PAR2 Mall Plaza Inter Managua',
    storeAddress: 'Avenida Bolívar, Costado Norte del Hotel Crowne Plaza Managua. Módulos 2A y 2B 2do Piso, Mall Plaza Inter Managua',
    schedule: 'Lunes a Domingo: 10:00am a 8:00pm',
    phone: '2277277',
    whatsapp: '75532016',
    page: 'https://maps.app.goo.gl/VQnZMmtyJH3TFn167',
    review: 'https://search.google.com/local/writereview?placeid=ChIJD0BF5tj9c48Rkjxe1uBDqvo',
    zona: 1,
    LatLng: [{
      lat: 12.139344299999999,
      lng: -86.2288748
    }],
    type: 'par2'
  },
  {
    storecode: 'P06',
    placeName: 'PAR 2 CC Metrocentro Managua',
    storeAddress: 'Leon, Frente a Plaza Siglo XXI Del Mercado Central, 1 c. al Nte. y 1/2 cuadra al este',
    schedule: 'Lunes a Sábado: 08:30am a 06:00pm<br>Domingo: 08:00am - 03:00pm',
    phone: '23116111',
    whatsapp: '83510802',
    page: 'https://maps.app.goo.gl/qapzgM7Ecarh8AJz7',
    review: 'https://search.google.com/local/writereview?placeid=ChIJkV_TlfpVcY8RypjStxjCdS0',
    zona: 1,
    LatLng: [{
      lat: 12.128511100000001,
      lng: -86.264948799999999
    }],
    type: 'par2'
  },
  {
    storecode: 'P07',
    placeName: 'PAR2 Leon',
    storeAddress: 'C.C. Metro Centro Managua, Mod C-33',
    schedule: 'Lunes a Sábado: 10:00am a 08:00pm<br>Domingo: 11:00am - 07:00pm',
    phone: '22719112',
    whatsapp: '83510831',
    page: 'https://maps.app.goo.gl/MYgcFVACC9wkX6ft8',
    review: 'https://search.google.com/local/writereview?placeid=ChIJEayIaEkfcY8R4XeoZZ4yzTI',
    zona: 1,
    LatLng: [{
      lat: 12.436067899999999,
      lng: -86.876450399999996
    }],
    type: 'par2'
  },
  {
    storecode: 'P08',
    placeName: 'PAR2 CC Multicentro Las Americas',
    storeAddress: 'C.C. Multicentro Las Americas,',
    schedule: 'Lunes a Domingo: 10:00am a 8:00pm',
    phone: '22777773',
    whatsapp: '83510816',
    page: 'https://maps.app.goo.gl/49NGsfZ7zRcdnAYP6',
    review: 'https://search.google.com/local/writereview?placeid=ChIJ6Z_69x79c48R6oofXzW15FE',
    zona: 1,
    LatLng: [{
      lat: 12.147452400000001,
      lng: -86.2564536
    }],
    type: 'par2'
  },
  {
    storecode: 'P09',
    placeName: 'PAR2 Chinandega',
    storeAddress: 'De la esquina de los bancos 1/2 Cuadra al este Chinandega',
    schedule: 'Lunes a Sábado: 09:00am a 06:00pm<br>Domingo: 09:00am - 03:00pm',
    phone: '23410416',
    whatsapp: '83510801',
    page: 'https://maps.app.goo.gl/49NGsfZ7zRcdnAYP6',
    review: 'https://search.google.com/local/writereview?placeid=ChIJ6Z_69x79c48R6oofXzW15FE',
    zona: 1,
    LatLng: [{
      lat: 12.147452400000001,
      lng: -86.2564536
    }],
    type: 'par2'
  },
  {
    storecode: 'P08',
    placeName: 'PAR2 Esteli',
    storeAddress: 'Calle de los bancos, banco Lafise ½ al norte',
    schedule: 'Lunes a Sábado: 09:00am a 06:30pm<br>Domingo: 09:00am - 02:30pm',
    phone: '75532017',
    whatsapp: '75532017',
    page: 'https://maps.app.goo.gl/49NGsfZ7zRcdnAYP6',
    review: 'https://search.google.com/local/writereview?placeid=ChIJ6Z_69x79c48R6oofXzW15FE',
    zona: 1,
    LatLng: [{
      lat: 12.147452400000001,
      lng: -86.2564536
    }],
    type: 'par2'
  }
  
];  

var coll = document.getElementsByClassName("collapsible");
var i;

for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function() {
    this.classList.toggle("actived");
    var content = this.nextElementSibling;
    if (content.style.display === "block") {
      content.style.display = "none";
    } else {
      content.style.display = "block";
    }
  });
}

function addMarkerInfo(){
  for(var i=0; i < markersOnMap.length; i++){
    var contentString = '<div class="place-name">' + markersOnMap[i].placeName + '</div>';
    contentString += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
    contentString += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
    if(markersOnMap[i].phone !== "")
    	contentString += '<div class="place-link"><a class="place-link" href="tel:+505'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="Hush Puppies El Salvador" style="width: 4%"> (505)'+ markersOnMap[i].phone + '</a></div>';
    contentString += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=505'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="Hush Puppies El Salvador" style="width: 4%"> (505)' + markersOnMap[i].whatsapp + '</a></div>';
    contentString += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="Hush Puppies El Salvador" style="width: 4%"> Navegar en Waze</a></div>';
    if(markersOnMap[i].page !== "")
    	contentString += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
    if(markersOnMap[i].review !== "")
    contentString += '<div class="place-link"><button class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div>';

    const marker = new google.maps.Marker({
      position: markersOnMap[i].LatLng[0],
      icon: icons[markersOnMap[i].type].icon,
      map: map
    });

    const infowindow = new google.maps.InfoWindow({
      content: contentString
    });


    marker.addListener('click', function(){
      closeOtherInfo();
      infowindow.open(marker.get('map'),marker);
      InfoObj[0] = infowindow;
    });
    
    switch (markersOnMap[i].zona) {
      case 1: 
            var contentDiv = '<div class="contentDiv" onclick="SetCenterMap('+markersOnMap[i].LatLng[0].lat+','+markersOnMap[i].LatLng[0].lng+')"><div class="place-name">' + markersOnMap[i].placeName + '</div>';
            contentDiv += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
            contentDiv += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
            if(markersOnMap[i].phone !== "")
                contentDiv += '<div class="place-link"><a class="place-link" href="tel:+505'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="Hush Puppies El Salvador" style="width: 4%"> (505)'+ markersOnMap[i].phone + '</a></div>';
            contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=505'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="Hush Puppies El Salvador" style="width: 4%">(505)' + markersOnMap[i].whatsapp + '</a></div>';
            contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="Hush Puppies El Salvador" style="width: 4%"> Navegar en Waze</a></div>';
            if(markersOnMap[i].page !== "")
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
            if(markersOnMap[i].review !== "")
            contentDiv += '<div class="place-link"><button class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div></div>';    

            document.getElementById("add-info").innerHTML += contentDiv;
            break;
    }
  }
}

function closeOtherInfo(){
  if(InfoObj.length > 0){
    InfoObj[0].set("marker", null);
    InfoObj[0].close();
    InfoObj[0].length = 0;
  }
}

function SetCenterMap(posLat, posLon){
  var centerStore = {lat: posLat, lng: posLon};
  map.setCenter(centerStore);
}

function positionOk(pos){
  var latitudeMap = pos.coords.latitude;
  var longitudMap = pos.coords.longitude;
  var centerStore = {lat: latitudeMap, lng: longitudMap};
  map.setCenter(centerStore);
}

function positionKO(){
  const centerStore = {lat: 13.706105, lng: -89.2119793};
  map.setCenter(centerStore);
}

function initMap(){
  map = new google.maps.Map(document.getElementById('map'),{
    zoom: 16,
    center: {lat: 13.706105, lng: -89.2119793},
    mapId: '7b2b8c05c9abdb62'
  });

  if(navigator.geolocation){
    navigator.geolocation.getCurrentPosition(positionOk, positionKO);            
  }

  addMarkerInfo();
};

function openPage(pageName,elmnt) {
  var i, tabcontent;
  
  tabcontent = document.getElementsByClassName("tabcontent2");
  
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  };
    
  document.getElementById(pageName).style.display = "block";
  elmnt.style.borderBottom = "6px solid #FF6B00";

  document.getElementById("map").style.width = "200px";
}